export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const NOMENCLATURE_UAH = '8f1217dd-7938-11e4-abef-005056b97444';
export const CONTRY_UKRAINE = 'e7bc124e-f98b-11e9-bad4-005056b9cacb';
export const WOG_GUID = 'd43e5aa0-2010-11ea-bad4-005056b9cacb';
